import { useSelector } from 'react-redux';
import { useConfigurationCanvasContext } from './ConfigurationCanvasContext';
import { selectPillsMap } from '../../canvas-pills/canvasPillsReducer';

export const useConfigurationCanvasState = () => {
  const { canvasFunnelMap, setCanvasFunnelMap } = useConfigurationCanvasContext();

  const pills = useSelector(selectPillsMap);

  return {
    canvasFunnelMap,
    setCanvasFunnelMap,
    pills,
  };
};
